import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? null : id));
  };

  return (
    <section id="faq" className="scroll-mt-24 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 lg:gap-12">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="第一次来，先看这几个问题"
              desc="关于更新节奏、内容来源和使用方式，答案都在这儿。如果还有没覆盖到的，可以通过页面底部的联系方式告诉我们。"
              tone="secondary"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4 hidden lg:block">
              <p className="text-sm text-foreground-700 leading-relaxed">
                还有别的疑问？在底部留言，我们通常会在 1 个工作日内回复。
              </p>
              <a
                href="#contact"
                className="mt-3 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                去留言
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => toggle(item.id)}
                      aria-expanded={open}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-950">{item.q}</span>
                      <span
                        className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <div className="px-4 md:px-5 pb-4 -mt-1 animate-fade-up">
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}